



























import Vue from 'vue'
import { defaultPosterImage } from '../../helper/constants'
export default Vue.extend({
  props: {
    productId: {
      type: String
    },
    productTitle: {
      type: String
    },
    posterImage: {
      type: String
    }
  },
  data() {
    return {
      defaultPosterImage
    }
  }
})
